import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ModalComponent } from './components/modal/modal.component';
import { ModalsComponent } from './components/modals/modals.component';

import { ModalDirective } from './directives/modal.directive';
import { ShowModalDirective } from './directives/show-modal.directive';

@NgModule({
  declarations: [
    ModalsComponent,
    ModalComponent,
    ShowModalDirective,
    ModalDirective
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ModalsComponent,
    ShowModalDirective,
    ModalDirective
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ClooperModalsModule {}
